var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"icon":"","color":"success","loading":_vm.loading},on:{"click":_vm.onDownloadClick}},'v-btn',_vm.$attrs,false),[_c('v-fa-icon',{attrs:{"icon":"download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }